<template>
	<div class="app-container">
		<el-dialog
			ref="dialog"
			:title="setTitle"
			:visible.sync="showDialog"
			width="50%"
			@close="closeDialog"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
		>
			<el-form
				:rules="rules"
				ref="form"
				:model="boxData"
				label-width="130px"
				:key="showType + currentId"
			>
				<el-form-item
					v-if="showType == 2 || boxData.parentId"
					prop="id"
					label="所属一级类别"
				>
					<div class="form-text" v-if="addAndEdit()">
						{{ showFirstText(currentId) }}
					</div>
					<div class="form-text" v-else>
						{{ showFirstText(boxData.parentId) }}
					</div>
				</el-form-item>
				<el-form-item
					prop="name"
					:label="showType == 2 ? '二级类别名称' : '类别名称'"
				>
					<el-input
						clearable
						maxlength="50"
						v-if="addAndEdit()"
						:placeholder="
							showType == 2
								? '请输入二级类别名称，限制50个字符'
								: '请输入类别名称，限制50个字符'
						"
						v-model.trim="boxData.name"
						@input="inputChange('name')"
					></el-input>
					<div class="form-text" v-else>
						{{ boxData.name }}
					</div>
				</el-form-item>
				<el-form-item prop="code" label="类别编码">
					<el-input
						clearable
						maxlength="20"
						v-if="addAndEdit()"
						:disabled="showType == 3 || showType == 4"
						placeholder="请输入类别编码，只允许输入英文大写字母，限制20个字符"
						v-model.trim="boxData.code"
						@input="inputChange('code')"
					></el-input>
					<div class="form-text" v-else>
						{{ boxData.code }}
					</div>
				</el-form-item>
				<el-form-item label="类别说明">
					<el-input
						v-if="addAndEdit()"
						clearable
						maxlength="300"
						placeholder="请输入类别说明，限制300个字符"
						show-word-limit
						type="textarea"
						v-model.trim="boxData.typeDesc"
						@input="inputChange('typeDesc')"
					></el-input>
					<div class="form-text" v-else>
						{{ boxData.typeDesc }}
					</div>
				</el-form-item>
				<el-form-item
					v-if="showType == 2 || boxData.parentId"
					label="关联属性"
				>
					<template v-if="addAndEdit()">
						<el-checkbox
							label="性别"
							name="genderPropertyFlag"
							v-model="boxData.genderPropertyFlag"
						></el-checkbox>
						<el-checkbox
							label="婚姻"
							name="maritalPropertyFlag"
							v-model="boxData.maritalPropertyFlag"
						></el-checkbox>
					</template>
					<div class="form-text" v-else>
						<el-tag v-if="boxData.genderPropertyFlag === 'YES'"
							>性别</el-tag
						>
						<el-tag v-if="boxData.maritalPropertyFlag === 'YES'"
							>婚姻</el-tag
						>
						<el-tag
							v-if="
								boxData.maritalPropertyFlag === 'NO' &&
								boxData.genderPropertyFlag === 'NO'
							"
							>无</el-tag
						>
					</div>
				</el-form-item>
				<div v-if="addAndEdit()" class="button-box">
					<el-button @click="cancel">取消</el-button>
					<el-button @click="submit" type="primary">保存</el-button>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			var validateCode = (rule, value, callback) => {
				if (!value) {
					callback(new Error("类别编码不能为空"));
				} else if (!this._valid._limitUpperEn(value)) {
					callback(new Error("只允许输入英文大写字母，限制20个字符"));
				} else {
					callback();
				}
			};
			let rules = {
				parentId: [
					{
						required: true,
						message: "请选择所属一级类别",
						trigger: "change",
					},
				],
				name: [
					{
						required: true,
						message: "类别名称不能为空，限制50个字符",
						trigger: ["blur", "change"],
					},
				],
				code: [
					{
						required: true,
						validator: validateCode,
						trigger: ["blur", "change"],
					},
				],
			};
			return {
				showDialog: this.show,
				showType: this.type,
				currentId: this.current,
				errorObj: {},
				boxData: {
					maritalPropertyFlag: false,
					genderPropertyFlag: false,
					parentId: 0,
					code: "",
				}, // 数据
				rules, // 规则
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			detail: {
				type: Object,
				default: null,
			},
			type: {
				type: Number,
				default: 0, // 1-新建一级 2-新建二级 3-编辑-级 4-编辑二级 5-查看一级 6-查看二级
			},
			current: {
				type: Number,
				default: 0, //如果增加二级，那么currentid就是新增的parentId
			},
		},
		computed: {
			setTitle: function () {
				switch (this.showType) {
					case 1:
						return "新增一级服务类别";
					case 2:
						return "新增二级服务类别";
					case 3:
						return "编辑一级服务类别";
					case 4:
						return "编辑二级服务类别";
					case 5:
						return "一级服务类别";
					case 6:
						return "二级服务类别";
				}
				return "";
			},
		},
		watch: {
			show: function (value) {
				this.showDialog = value;
			},
			detail: function (value) {
				this.editData = value;
				this.boxData = this.editData;
			},
			current(value) {
				this.currentId = value;
				this?.$refs?.form?.clearValidate && this.$refs.form.resetFields();
			},
			type(value) {
				this.showType = value;
			},
		},
		methods: {
			closeDialog() {
				this.$emit("editReceive", {
					key: "showEdit",
					value: false,
				});
			},
			showFirstText(pid) {
				const data = this.$parent.treeList.find((el) => el.id === pid);
				console.log(data);
				if (data) {
					this.currentId = pid;
					return data?.name;
				}
			},
			inputChange(name) {
				let num;
				if (name === "code") {
					num = 20;
				} else if (name === "typeDesc") {
					num = 300;
				} else if (name === "name") {
					num = 50;
				}
				this.boxData[name] = this.boxData[name].slice(0, num);
			},
			/**
			 * 判断是编辑还是新建
			 * @returns {Boolean} true-编辑|新建 false-查看|其他
			 */
			addAndEdit() {
				return this.showType <= 4 && this.showType !== 0;
			},
			/**
			 * 清空数据
			 */
			clearBoxData() {
				this.boxData = {
					maritalPropertyFlag: false,
					genderPropertyFlag: false,
					parentId: undefined,
					name: undefined,
					code: undefined,
					typeDesc: undefined,
				};
				this?.$refs?.form?.clearValidate && this.$refs.form.resetFields();
				this.$forceUpdate();
			},
			/**
			 * 点击取消
			 */
			cancel() {
				this?.$refs?.form?.clearValidate && this.$refs.form.resetFields();
				this.clearBoxData();
				this.closeDialog();
			},
			/**
			 * 右侧保存按钮
			 */
			submit() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						const param = { ...this.boxData };
						Object.keys(param).forEach((item) => {
							if (param[item] === true) param[item] = "YES";
							if (param[item] === false) param[item] = "NO";
						});
						if (this.showType == 2) {
							param.parentId = this.currentId;
						}
						//这里区分添加一级还是二级TODO
						this.toDo(param);
					}
				});
			},
			async toDo(param) {
				const res = await this.axios.post(
					this.getApiUrl(
						this.showType === 3 || this.showType === 4
							? "serviceTypeEdit"
							: "serviceTypeCreate"
					),
					param,
					{
						toJSON: true,
					}
				);
				if (res.code === 1) {
					this.$message({
						type: "success",
						message:
							this.showType === 3 || this.showType === 4
								? "操作成功！"
								: "新建成功",
					});
					this.$emit("reload");
					this.closeDialog();
				} else {
					this.$message.warning(res.msg);
				}
			},
		},
		created() {
			var lett = this;
			document.onkeydown = function (e) {
				var key = window.event.keyCode;
				var button = document.querySelector(".dialog-btn");
				if (!button) return;
				if (key == 13) {
					lett.onSubmit("form");
				}
			};
		},
	};
</script>
<style rel="stylesheet/scss" lang="scss">
	.button-box {
		height: 100%;
		display: flex;
		justify-content: space-around;
	}
</style>